<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<h1 class="toc-title">T<span class="smallcaps">ABLE OF</span> C<span class="smallcaps">ONTENTS</span></h1>
<h2 class="toc"><a href="#/xhtml/07_Acknowledgments">Acknowledgments</a></h2>
<h2 class="toc"><a href="#/xhtml/08_Foreword">Foreword by Terrence J. Winschel</a></h2>
<h2 class="toc"><a href="#/xhtml/09_Introduction">Introduction</a></h2>
<h2 class="toc"><a href="#/xhtml/11_Chapter1">Chapter 1: Old Joe</a></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter2" title="Link target outside of Sample">Chapter 2: Days of Scramble</span></h2>
<h2 class="toc"><span href="#/xhtml/13_Chapter3" title="Link target outside of Sample">Chapter 3: Hour of Trial Is On Us</span></h2>
<h2 class="toc"><span href="#/xhtml/14_Chapter4" title="Link target outside of Sample">Chapter 4: The Head-Quarters of Everything</span></h2>
<h2 class="toc"><span href="#/xhtml/15_Chapter5" title="Link target outside of Sample">Chapter 5: The Decision to Move on Jackson</span></h2>
<h2 class="toc"><span href="#/xhtml/16_Chapter6" title="Link target outside of Sample">Chapter 6: A Show of Saving the City</span></h2>
<h2 class="toc"><span href="#/xhtml/17_Chapter7" title="Link target outside of Sample">Chapter 7: Life No Charm, Death No Horror</span></h2>
<h2 class="toc"><span href="#/xhtml/18_Chapter8" title="Link target outside of Sample">Chapter 8: All Fire and Spirit</span></h2>
<h2 class="toc"><span href="#/xhtml/19_Chapter9" title="Link target outside of Sample">Chapter 9: Good-Night at the Stars</span></h2>
<h2 class="toc"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample">Chapter 10: Destruction of the City</span></h2>
<h2 class="toc"><span href="#/xhtml/21_Chapter11" title="Link target outside of Sample">Chapter 11: Whose Hearts Should Be as Brothers</span></h2>
<h2 class="toc"><span href="#/xhtml/22_Chapter12" title="Link target outside of Sample">Chapter 12: The Jackson Battlefield</span></h2>
<h2 class="toc"><span href="#/xhtml/23_Chapter13" title="Link target outside of Sample">Order of Battle</span></h2>
<h2 class="toc"><span href="#/xhtml/24_Sources" title="Link target outside of Sample">Sources</span></h2>
<h2 class="toc"><span href="#/xhtml/25_Author" title="Link target outside of Sample">About the Author</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?8ef2ded6